export default __webpack_public_path__ + "static/media/successStatus.b89085a1.svg";